import {
  actionTypes as asyncTypes,
  isAsyncOperation,
  isAsyncComplete,
  isAsyncFailure,
} from "async-ops";
import { GET_AUDIT_STATUS } from "../services/get-audit-status";
import {
  isMdaeWidgetOptionChangeEvent,
  updateStateAfterWidgetOptionChange,
} from "../../../common_components/mdae-framework";
import { callOperation } from "async-ops";

import { cloneDeep, cloneDeepWith, first, isEmpty, isNil } from "lodash";
import { GET_PROCESS_MANAGERS_LIST } from "../services/get-process-managers-list";
import { GET_CODE_TYPES_LOOKUPS } from "../services/get-code-types-lookups";
import { GET_AUDIT_PERIOD } from "../services/get-audit-period";
import { GET_CURRENT_USER } from "../../../common_components/common_widgets/navigation_bar/services/get-current-user";
import { GET_AUDIT_GROUPS } from "../services/get-audit-groups";
import { GET_TARGET_DATA_LOOKUPS } from "../services/get-target-data-lookups";
import { auditModes, COMPLETED_SATUS } from "../constants";
import { HIDE_LOADER, SHOW_LOADER } from "../../../common_components/mdae-common-reducer";
import { GET_AUDIT_GROUP_BY_ID } from "../services/get-audit-group-by-id";
import { toggleAuditGroupProcessManagerWarningPopup } from "../audit-group-process-manager-warning-popup";
import { GET_TARGET_RATIONALE_LOOKUP_DATA } from "../services/get-target-rationale-lookup-data";
import { GET_PROCESS_TEMPLATE_BY_ID } from "../../external-audit-setup/process-template/services/get-process-template-by-id";
import { GET_EA_REQUESTER_BY_ID } from "../services/get-requester-by-id";
import { SET_CASE_FORM_DATA } from "../case-detail/case-data/reducers/case-data-reducer";
import { GET_AUDIT_PROPERTIES } from "../services/get-audit-properties";
import { CASE_SEARCH_CRITERIA_POPUP_LOCATIONS } from "../../../common_components/case-search/case-search-list-popup";

export const SET_TARGET_TYPES_LOOKUP = "SET_TARGET_TYPES_LOOKUP";
export const SET_TARGET_VALUE_LOOKUP = "SET_TARGET_VALUE_LOOKUP";
export const SET_PROCESS_MANAGERS_LIST = "SET_PROCESS_MANAGERS_LIST";
export const SET_TARGET_TYPE_VALUE_DATA_SOURCE =
  "SET_TARGET_TYPE_VALUE_DATA_SOURCE";
export const SET_AUDIT_PROPERTIES_DATA = "SET_AUDIT_PROPERTIES_DATA";
export const SET_PROCESS_TEMPLATES_DATA_SOURCE =
  "SET_PROCESS_TEMPLATES_DATA_SOURCE";
export const SET_REQUESTER_DATA_SOURCE = "SET_REQUESTER_DATA_SOURCE";
export const SET_TARGET_TYPE_SELECTION = "SET_TARGET_TYPE1_SELECTION";
export const SET_PROCESS_TEMPLATE_REQUIRED_FIELDS =
  "SET_PROCESS_TEMPLATE_REQUIRED_FIELDS";
export const SET_CURRENT_SELECTED_AUDIT_ID = "SET_CURRENT_SELECTED_AUDIT_ID";
export const SET_CLAIM_TYPE_DATA_SOURCE = "SET_CLAIM_TYPE_DATA_SOURCE";
export const TOGGLE_NOTIFICATION_DATE_WARNING_POPUP =
  "TOGGLE_NOTIFICATION_DATE_WARNING_POPUP";
export const SET_EXTERNAL_AUDIT_SCROLL_VIEW_HEIGHT =
  "SET_EXTERNAL_AUDIT_SCROLL_VIEW_HEIGHT";
export const SET_CURRENT_AUDIT_GROUP_ID = "SET_CURRENT_AUDIT_GROUP_ID";
export const SET_PREVIOUS_NOTIFICATION_DATE_SELECTION =
  "SET_PREVIOUS_NOTIFICATION_DATE_SELECTION";
export const TOGGLE_CLAIM_TYPE_WARNING_POPUP =
  "TOGGLE_CLAIM_TYPE_WARNING_POPUP";
export const TOGGLE_AUDIT_STATUS_WARNING_POPUP =
  "TOGGLE_AUDIT_STATUS_WARNING_POPUP";
export const SET_REQUESTER_DATA = "SET_REQUESTER_DATA";
export const SET_USER_TASKS_LIST = "SET_USER_TASKS_LIST";
export const SET_OLD_AUDIT_PROPERTIES_OBJECT =
  "SET_OLD_AUDIT_PROPERTIES_OBJECT";
export const TOGGLE_AUDIT_GROUP_PROCESS_WARNING_POPUP =
  "TOGGLE_AUDIT_GROUP_PROCESS_WARNING_POPUP";
export const TOGGLE_AUDIT_GROUP_PROCESS_MANAGER_WARNING_POPUP =
  "TOGGLE_AUDIT_GROUP_PROCESS_MANAGER_WARNING_POPUP";
export const SET_IS_SET_TARGET_CODE_VALUES = "SET_IS_SET_TARGET_CODE_VALUES";
export const SET_EXTERNAL_AUDIT_READ_ONLY = "SET_EXTERNAL_AUDIT_READ_ONLY";
export const SET_AUDIT_GROUP_SPECIFIC_PROCESS_TEMPLATE =
  "SET_AUDIT_GROUP_SPECIFIC_PROCESS_TEMPLATE";
export const SET_IS_COMPONENT_LOADED_FLAG = "SET_IS_COMPONENT_LOADED_FLAG";
export const SET_IS_REVIEW_CONTRACTOR_VALID_FOR_REQUESTER = "SET_IS_REVIEW_CONTRACTOR_VALID_FOR_REQUESTER";
export const TOGGLE_EDIT_REQUESTER_ALERT_POPUP = "TOGGLE_EDIT_REQUESTER_ALERT_POPUP";
export const SET_IS_INITIAL_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR = "SET_IS_INITIAL_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR";
export const SET_VALID_INITIAL_CONTENT_TYPE_LIST = "SET_VALID_INITIAL_CONTENT_TYPE_LIST";
export const GET_IS_REVIEW_CONTRACTOR_INVALID_FOR_REQUESTER = "GET_IS_REVIEW_CONTRACTOR_INVALID_FOR_REQUESTER";
export const TOGGLE_UPDATE_REQUESTER_INFO_WARNING_POPUP = "TOGGLE_UPDATE_REQUESTER_INFO_WARNING_POPUP";
export const SET_AUDIT_GROUPS = "SET_AUDIT_GROUPS";
export const auditRLLODataSource=[
  {id: 1, name: 'Yes'},
  {id: 0, name: 'No'}
];
export const defaultAuditPropertiesData = {
  eaAuditId: 0,
  title: "",
  auditGroupId: null,
  eaProcessTemplateId: null,
  processManagerId: null,
  referenceId: "",
  notificationDate: null,
  statusId: 0,
  auditPeriodId: null,
  startDate: new Date(),
  completionDate: null,
  eaRequesterId: null,
  eaSourceId: null,
  claimTypeCd: null,
  paymentReviewInd: false,
  serviceFromDate: null,
  serviceToDate: null,
  eaCategoryId: 0,
  targetType1: null,
  targetValue1: null,
  targetType2: null,
  targetValue2: null,
  rqstrOrganizationName: "",
  rqstrMainPhoneNumber: null,
  rqstrMainEmail: null,
  rqstrContactName: null,
  rqstrContactPhoneNumber: null,
  rqstrContactEmail: null,
  rqstrNotes: "",
  rqstrRecordSubmissionMethod: null,
  rqstrRecordSubmissionValue: "",
  narrativeSummary: "summary",
  activeInd: null,
  clientId: 0,
  termedProcessTemplate:{},
  filterAuditGroups:[],
  documentId:0,
  s3ObjectName:'',
  targetRationaleValue:null,
  emdrClaimType:"",
  isRoundLineLevelTrackingEnabled:1,
  processTemplateClaimTypeCd:"",
  requesterClaimTypeCd:'',
  isUpdateInitialRequesterOrganizationPopupVisible:false
};

export const defaultRequesterData = {
  eaRequesterId: 0,
  rqstrOrganizationName: "",
  rqstrMainPhoneNumber: null,
  rqstrMainEmail: null,
  rqstrContactName: null,
  rqstrContactPhoneNumber: null,
  rqstrContactEmail: null,
  rqstrNotes: "",
  rqstrRecordSubmissionMethod: null,
  rqstrRecordSubmissionValue: "",
  claimTypeCd: null,
  activeInd: null,
  clientId: 0,
  effectiveDate: null,
  termDate: null,
  createdBy: null,
  createDate: null,
  updatedBy: null,
  updateDate: null,
};

const initialState = {
  auditStatus: [],
  targetTypes: [],
  targetValueLookup: [],
  allProcessManagersList: [],
  processManagers: [],
  auditPropertiesData: defaultAuditPropertiesData,
  submissionMethod: [],
  auditPeriod: [],
  processTemplateDataSource: [],
  requesterDataSource: [],
  auditGroups: [],
  requesterData: defaultRequesterData,
  patientTypes: [],
  isSetTargetCodeValue: false,
  targetRationaleList: [],
  filteredAuditGroups: [],
};

export default function(state = initialState, action) {
  let newState;
  switch (action.type) {
    case SET_TARGET_TYPES_LOOKUP:
      if (action.currentTagetType === 1) {
        return {
          ...state,
          targetTypes: action.targetTypes,
        };
      } else {
        return {
          ...state,
          targetTypes2: action.targetTypes2,
        };
      }
    case SET_AUDIT_GROUP_SPECIFIC_PROCESS_TEMPLATE:
      return {
        ...state,
        filteredAuditGroupList: action.data.filterAuditGroups,
      };
    case SET_PROCESS_MANAGERS_LIST:
      newState = cloneDeepWith(state);
      let filteredManagersList = newState.allProcessManagersList.filter(
        (x) => x.auditGroupId === action.auditGroupId
      );
      return {
        ...newState,
        processManagers: filteredManagersList,
      };

    case SET_AUDIT_PROPERTIES_DATA:
      newState = { ...state };
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = {
          ...newState,
          auditPropertiesData: {
            ...state.auditPropertiesData,
            ...action.data.auditPropertiesData,
          },
        };
      }
      return newState;
    case SET_TARGET_TYPE_VALUE_DATA_SOURCE:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        if (action.currentTagetType == 1) {
          if (
            action.codeTypeValue?.toLowerCase() === "provider" &&
            newState.auditPropertiesData.claimTypeCd === "P"
          ) {
            let renderingProviders = action.targetType1ValueSource.filter(
              (x) => x.isRenderingProvider == "Y"
            );
            newState = {
              ...newState,
              targetType1ValueSource: renderingProviders,
            };
          } else {
            newState = {
              ...newState,
              targetType1ValueSource: action.targetType1ValueSource,
            };
          }
        } else if (
          action.codeTypeValue?.toLowerCase() === "provider" &&
          newState.auditPropertiesData.claimTypeCd === "P"
        ) {
          let renderingProviders = action.targetType2ValueSource.filter(
            (x) => x.isRenderingProvider == "Y"
          );
          newState = {
            ...newState,
            targetType2ValueSource: renderingProviders,
          };
        } else {
          newState = {
            ...newState,
            targetType2ValueSource: action.targetType2ValueSource,
          };
        }
        newState = {
          ...newState,
          targetType2ValueSource: action.targetType2ValueSource,
        };
      }
      return newState;
    case SET_PROCESS_TEMPLATES_DATA_SOURCE:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.processTemplateDataSource)) {
        newState = updateStateAfterWidgetOptionChange(
          newState,
          action.processTemplateDataSource
        );
      } else {
        newState = {
          ...newState,
          processTemplateDataSource: action.processTemplateDataSource,
        };
      }
      return newState;

    case SET_REQUESTER_DATA_SOURCE:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.requesterDataSource)) {
        newState = updateStateAfterWidgetOptionChange(
          newState,
          action.requesterDataSource
        );
      } else {
        newState = {
          ...newState,
          requesterDataSource: action.requesterDataSource,
        };
      }
      return newState;
    case SET_TARGET_TYPE_SELECTION:
      return {
        ...state,
        targetType1Selection: action.targetType1Selection,
        targetType2Selection: action.targetType2Selection,
      };
    case SET_PROCESS_TEMPLATE_REQUIRED_FIELDS:
      return {
        ...state,
        selectedProcessTemplateRequiredFields:
          action.selectedProcessTemplateRequiredFields,
      };
    case SET_CURRENT_SELECTED_AUDIT_ID:
      return {
        ...state,
        selectedAuditId: action.data.selectedAuditId,
      };
    case SET_CLAIM_TYPE_DATA_SOURCE:
      return {
        ...state,
        claimTypes: action.claimTypes,
      };
    case SET_CURRENT_AUDIT_GROUP_ID:
    
    case SET_EXTERNAL_AUDIT_READ_ONLY:
    case TOGGLE_EDIT_REQUESTER_ALERT_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_EXTERNAL_AUDIT_SCROLL_VIEW_HEIGHT:
      return  { ...state, ...action.data }
    case SET_PREVIOUS_NOTIFICATION_DATE_SELECTION:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = {
          ...newState,
          prevNotificationDate: action.data.notificationDate,
        };
      }
      return newState;
    case SET_REQUESTER_DATA:
      newState = cloneDeepWith(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const requesterDataSet = newState.requesterDataSet
          ? newState.requesterDataSet
          : {};
        for (let prop in action.data.requesterDataSet) {
          requesterDataSet[prop] = action.data.requesterDataSet[prop];
        }
        newState = { ...newState, newRequesterData: requesterDataSet };
      }
      return newState;
    case SET_USER_TASKS_LIST:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        const inCompleteTaskList = action.data.userTaskList?.filter(
          (x) =>
            x.status.toUpperCase() !== COMPLETED_SATUS &&
            x.requiredForAuditCompletionInd
        );
        newState = {
          ...newState,
          ...action.data,
          inCompleteTaskList: inCompleteTaskList,
        };
      }
      return newState;
    case SET_IS_COMPONENT_LOADED_FLAG:
      return { ...state, ...action.data };
    case SET_OLD_AUDIT_PROPERTIES_OBJECT:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = {
          ...newState,
          ...action,
          oldAuditPropertiesObject: action.data.oldAuditPropertiesObject,
        };
      }
      return newState;
    case TOGGLE_AUDIT_GROUP_PROCESS_MANAGER_WARNING_POPUP:
    case TOGGLE_AUDIT_GROUP_PROCESS_WARNING_POPUP:
    case TOGGLE_CLAIM_TYPE_WARNING_POPUP:
    case TOGGLE_AUDIT_STATUS_WARNING_POPUP:
    case TOGGLE_NOTIFICATION_DATE_WARNING_POPUP:
    case SET_VALID_INITIAL_CONTENT_TYPE_LIST:
    case TOGGLE_UPDATE_REQUESTER_INFO_WARNING_POPUP:
      newState = cloneDeep(state);
      if (isMdaeWidgetOptionChangeEvent(action.data)) {
        newState = updateStateAfterWidgetOptionChange(newState, action.data);
      } else {
        newState = { ...newState, ...action.data };
      }
      return newState;
    case SET_IS_SET_TARGET_CODE_VALUES:
      return { ...state, isSetTargetCodeValue: action.data };
    case SET_IS_REVIEW_CONTRACTOR_VALID_FOR_REQUESTER:
      return {...state,isInitialReviewContractorInvalidForRequester: action.data};
    case SET_IS_INITIAL_CONTENT_TYPE_INVALID_FOR_REVIEW_CONTRACTOR:
      return {...state, isInitialContentTypeInvalidForReviewContractor: action.data};
    case SET_AUDIT_GROUPS: {
      const { processTemplate } = action;
      const allAuditGroups = state.auditGroups || [];
      if (processTemplate.auditGroupNames !== "All") {
        const auditGroupIds = processTemplate.auditGroupAssociationList.map(
          (item) => item.auditGroupId
        );

        const filteredAuditGroups = allAuditGroups.filter((group) =>
          auditGroupIds.includes(group.auditGroupId)
        );

        return {
          ...state,
          filteredAuditGroups: filteredAuditGroups,
        };
      } else {
        return {
          ...state,
          filteredAuditGroups: allAuditGroups,
        };
      }
    }

    case asyncTypes.COMPLETE:
    case asyncTypes.FAILURE:
      if (isAsyncOperation(GET_AUDIT_STATUS)(action)) {
        return { ...state, auditStatus: [], allAuditStatusList: [] };
      }
      if (isAsyncComplete(GET_AUDIT_STATUS)(action)) {
        const response = action.response;
        let filteredValues = response.filter((x) => x.activeInd);
        return {...state,auditStatus: filteredValues, allAuditStatusList: response};
      }

      if (isAsyncOperation(GET_PROCESS_MANAGERS_LIST)(action)) {
        return { ...state, allProcessManagersList: [] };
      }
      if (isAsyncComplete(GET_PROCESS_MANAGERS_LIST)(action)) {
        const response = action.response;
        let filteredManagersList = response.filter(
          (x) => x.auditGroupId === state.auditPropertiesData?.auditGroupId
        );
        return {
          ...state,
          allProcessManagersList: response,
          processManagers: filteredManagersList,
        };
      }

      if (isAsyncOperation(GET_CODE_TYPES_LOOKUPS)(action)) {
        return { ...state, targetTypes: [], claimTypes: [] };
      }
      if (isAsyncComplete(GET_CODE_TYPES_LOOKUPS)(action)) {
        const response = action.response;
        return {
          ...state,
          submissionMethod: response.submissionMethods,
          targetTypes: response.targetTypesList,
          targetTypes2: response.targetTypesList,
          patientTypes: response.patientTypes,
          claimTypes: response.claimTypes,
          originalClaimTypes: response.claimTypes,
          eaAuditTypes: response.eaAuditTypes,
          isSetTargetCodeValue: true,
        };
      }
      if (isAsyncOperation(GET_TARGET_RATIONALE_LOOKUP_DATA)(action)) {
        return { ...state, targetRationaleList: [] };
      }
      if (isAsyncComplete(GET_TARGET_RATIONALE_LOOKUP_DATA)(action)) {
        const response = action.response;
        return {
          ...state,
          targetRationaleList: response.targetRationaleList,
        };
      }

      if (isAsyncOperation(GET_AUDIT_PERIOD)(action)) {
        return { ...state, auditStatus: [] };
      }
      if (isAsyncComplete(GET_AUDIT_PERIOD)(action)) {
        const response = action.response;
        return { ...state, auditPeriod: response };
      }

      if (isAsyncOperation(GET_CURRENT_USER)(action)) {
        return { ...state, currentUserId: 0 };
      }
      if (isAsyncComplete(GET_CURRENT_USER)(action)) {
        const response = action.response;
        return { ...state, currentUserId: response.userId };
      }

      if (isAsyncOperation(GET_AUDIT_GROUPS)(action)) {
        return { ...state, auditGroups: [] };
      }
      if (isAsyncComplete(GET_AUDIT_GROUPS)(action)) {
        const response = action.response;
        return {
          ...state,
          auditGroups: response.list,
          filteredAuditGroups: response.list,
        };
      }

      if (isAsyncOperation(GET_TARGET_DATA_LOOKUPS)(action)) {
        return { ...state };
      }
      if (isAsyncComplete(GET_TARGET_DATA_LOOKUPS)(action)) {
        const response = action.response;
      
        const uniqueProcessTemplates = [];
        const seenIds = new Set();
      
        for (const item of response.processList) {
          if (!seenIds.has(item.eaProcessTemplateId)) {
            seenIds.add(item.eaProcessTemplateId);
            uniqueProcessTemplates.push(item);
          }
        }
      
        return {
          ...state,
          requesterData: response.requesterList,
          processTemplateDataSource: uniqueProcessTemplates,
          contentTypeList: response.contentTypeList,
          reviewContractorContentTypeList: response.reviewContractorContentTypeList,
          reviewContractorList: response.reviewContractorList,
          recordSubmissionMethodEnums: response.recordSubmissionMethodEnums[0],
        };
      }
      

      return state;
    default:
      return state;
  }
}
const filterClaimTypeDataSource = (claimType, originalClaimTypes) => {
  if (claimType?.toUpperCase() === "I") {
    return originalClaimTypes?.filter(
      (x) => x.code !== "P" && x.code !== "A"
    );
  } else if (claimType?.toUpperCase() === "P") {
    return originalClaimTypes?.filter(
      (x) => x.code !== "I" && x.code !== "A"
    );
  } else {
    return originalClaimTypes;
  }
}


export const onAuditGroupValueChanged = (
  e,
  mode,
  allProcessManagersList,
  setProcessManagerToCurrentUser,
) => (dispatch, getstate) => {
  if (e.value) {
    dispatch({
      type: SET_PROCESS_MANAGERS_LIST,
      auditGroupId: e.value,
    });
    const location = getstate().caseDataReducer
      .caseData.location;
      const processTemplateClaimTypeCd = getstate().auditPropertiesReducer.auditPropertiesData.processTemplateClaimTypeCd;
      const requesterClaimTypeCd = getstate().auditPropertiesReducer.auditPropertiesData.requesterClaimTypeCd;

    if (location !== CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE) {
      dispatch({ type: SHOW_LOADER });
      callOperation(GET_AUDIT_GROUP_BY_ID, {
        auditGroupId: e.value,
      }).then((response) => {
        const originalClaimTypes = getstate().auditPropertiesReducer
          .originalClaimTypes;
        let filteredAuditGroupClaimType = response.auditGroupDto.claimTypeCd;
        let filterdClaimType = filterClaimTypeDataSource(
          filteredAuditGroupClaimType,
          originalClaimTypes
        );
        dispatch({
          type: SET_CLAIM_TYPE_DATA_SOURCE,
          claimTypes: filterdClaimType,
        });
        if(filterdClaimType && filterdClaimType.length==1){
          dispatch({
            type: SET_AUDIT_PROPERTIES_DATA,
            data: {
              auditPropertiesData: {
                
                ...(location !== CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE && {
                  claimTypeCd: filterdClaimType[0].code,
                })
              },
            },
          });
        }
        else if(filterdClaimType && filterdClaimType.length>1 && !isEmpty(processTemplateClaimTypeCd)){
          dispatch({
            type: SET_AUDIT_PROPERTIES_DATA,
            data: {
              auditPropertiesData: {
                ...(location !== CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE && {
                  claimTypeCd: processTemplateClaimTypeCd,
                })
              },
            },
          });
        }
        else if(!isEmpty(requesterClaimTypeCd)) {
          dispatch({
            type: SET_AUDIT_PROPERTIES_DATA,
            data: {
              auditPropertiesData: {
                ...(location !== CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE && {
                  claimTypeCd: requesterClaimTypeCd,
                })
              },
            },
          });
        }
        dispatch({ type: HIDE_LOADER });
      });
    }

    const processManagerId = getstate().auditPropertiesReducer
      .auditPropertiesData.processManagerId;
    if (mode == auditModes.EDIT && e.event && e.value) {
      if (processManagerId) {
        let filteredProcessManager = allProcessManagersList?.filter(
          (x) =>
            x.auditUserId === processManagerId && x.auditGroupId === e.value
        );
        if (filteredProcessManager[0]?.auditGroupId !== e.value) {
          toggleAuditGroupProcessManagerWarningPopup(true, dispatch);
        }
      }
    }
    if (mode == auditModes.CREATE) {
      setProcessManagerToCurrentUser();
    }
  }
};

export const onProcessTemplateValueChanged = (e, mode, toggleProcessChangeConfirmationPopupVisible, isCaseAuditInSync = false) => (dispatch,getstate) => {
  if (e.value) {
    let requesterId;
    const location = getstate().caseDataReducer.caseData.location;
    const allowedClaimType = getstate().auditPropertiesReducer.claimTypes;
    callOperation(GET_PROCESS_TEMPLATE_BY_ID, {
      eaProcessTemplateId: e.value,
    }).then((response) => {
      dispatch({
        type: SET_PROCESS_TEMPLATE_REQUIRED_FIELDS,
        selectedProcessTemplateRequiredFields:
          response.requiredFieldAssociationList,
      });
      if(response?.defaultAuditGroupId){
        dispatch({
          type: SET_PROCESS_MANAGERS_LIST,
          auditGroupId: response?.defaultAuditGroupId,
        });
      }
      dispatch({
        type: SET_AUDIT_GROUPS,
        processTemplate: response,
      });
      if (mode == auditModes.CREATE) {
        requesterId = response?.processTemplateRoundList[0]?.requesterId;
        let eaContentTypeId =
          response?.processTemplateRoundList[0]?.eaContentTypeId;
        let auditType = response?.auditType;
        var processTemplateClaimTypeCd = response?.claimTypeCd;
        const shouldSetPTClaim = dispatch(shouldSetProcessTemplateClaimType);
        dispatch({
          type: SET_AUDIT_PROPERTIES_DATA,
          data: {
            auditPropertiesData: {
               eaRequesterId: requesterId ,
               eaContentTypeId ,
               eaAuditType: auditType ,
               isRoundLineLevelTrackingEnabled: response.isRoundLineLevelTrackingEnabled,
              ...(response?.defaultAuditGroupId && {
                auditGroupId: response.defaultAuditGroupId,
              }),
              ...(shouldSetPTClaim && allowedClaimType.some(ct => ct.code === response?.claimTypeCd) && !isEmpty(processTemplateClaimTypeCd) && {
                claimTypeCd: processTemplateClaimTypeCd,
                processTemplateClaimTypeCd:processTemplateClaimTypeCd
              })
            },
          },
        });
        if (isCaseAuditInSync) {
          dispatch({
            type: SET_CASE_FORM_DATA,
            data: {
              caseData: {
                requesterId: requesterId,
                eaContentTypeId: eaContentTypeId,
              },
            },
          });
        }
        if (requesterId) {
          callOperation(GET_EA_REQUESTER_BY_ID, {
            requesterId: requesterId,
          }).then((response) => {
            dispatch({
              type: SET_AUDIT_PROPERTIES_DATA,
              data: {
                auditPropertiesData: {
                  rqstrOrganizationName: response?.rqstrOrganizationName,
                  rqstrMainPhoneNumber: response?.rqstrMainPhoneNumber,
                  rqstrMainEmail: response?.rqstrMainEmail,
                  rqstrContactName: response?.rqstrContactName,
                  rqstrContactPhoneNumber: response?.rqstrContactPhoneNumber,
                  rqstrContactEmail: response?.rqstrContactEmail,
                  rqstrNotes: response?.rqstrNotes,
                  rqstrRecordSubmissionMethod:
                    response?.rqstrRecordSubmissionMethod,
                  rqstrRecordSubmissionValue:
                    response?.rqstrRecordSubmissionValue,
                  eaSourceId: response?.eaSourceId,
                  ...( shouldSetPTClaim && allowedClaimType.some(ct => ct.code === response?.claimTypeCd) && isEmpty(processTemplateClaimTypeCd) && {
                      claimTypeCd: response?.claimTypeCd,
                    }),
                    ...( shouldSetPTClaim && allowedClaimType.some(ct => ct.code === response?.claimTypeCd) && {
                      requesterClaimType:response.claimTypeCd
                    }),
                },
              },
            });
            dispatch({ type: HIDE_LOADER });
            if (isCaseAuditInSync) {
              dispatch({
                type: SET_CASE_FORM_DATA,
                data: {
                  caseData: {
                    rqstrOrganizationName: response?.rqstrOrganizationName,
                    rqstrMainPhoneNumber: response?.rqstrMainPhoneNumber,
                    rqstrMainEmail: response?.rqstrMainEmail,
                    rqstrContactName: response?.rqstrContactName,
                    rqstrContactPhoneNumber: response?.rqstrContactPhoneNumber,
                    rqstrContactEmail: response?.rqstrContactEmail,
                    rqstrNotes: response?.rqstrNotes,
                    rqstrRecordSubmissionMethod:
                      response?.rqstrRecordSubmissionMethod,
                    rqstrRecordSubmissionValue:
                      response?.rqstrRecordSubmissionValue,
                      eaSourceId: response?.eaSourceId,
                    ...(location !== CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE && {
                      claimTypeCd: response?.claimTypeCd,
                    }),
                  },
                },
              });
            }
          });
        }
      }
      dispatch({ type: HIDE_LOADER });
    });
    if (e.value && e.event && mode == auditModes.EDIT) {
      let message =
        "Changing the process will delete all existing process round related tasks and data. Do you want to continue?";
      toggleProcessChangeConfirmationPopupVisible(true, message);
    }
  } else {
    dispatch({
      type: SET_PROCESS_TEMPLATE_REQUIRED_FIELDS,
      selectedProcessTemplateRequiredFields: [],
    });
  }
};
export const sortSelectedItemsOnTop = (
  allItems: Array<{ value: number | string; [key: string]: any }>,
  selectedValues?: Array<number | string> | null 
) => {
  if (!isNil(selectedValues) && !isEmpty(selectedValues) && Array.isArray(selectedValues)) {
    if (selectedValues.length > 0) {
      const selected = (selectedValues ?? []).map(String);

      return [...(allItems || [])].sort((a, b) => {
        const selectedItems = selected.includes(String(a.value));
        const unselectedItems = selected.includes(String(b.value));

        if (selectedItems && !unselectedItems) return -1;
        if (!selectedItems && unselectedItems) return 1;
        return 0;
      });
    }
  }
  return [...(allItems || [])]
};
export const getAuditData = (auditId) => (dispatch) => {
  if (auditId > 0) {
    callOperation(GET_AUDIT_PROPERTIES, {
      auditId: auditId,
    }).then(function(response) {
      dispatch({
        type: SET_AUDIT_PROPERTIES_DATA,
        data: {
          auditPropertiesData: response.auditPropertiesData,
        },
      });
    });
  }
};
export const shouldSetClaimType = (dispatch, getState) => {
  const state = getState();
  const auditPropertiesData = state.auditPropertiesReducer.auditPropertiesData;
  return (
    !auditPropertiesData.documentId ||
    isEmpty(auditPropertiesData.emdrClaimType)
  );
};

export const shouldSetProcessTemplateClaimType = (dispatch, getState) => {
  const state = getState();
  const location = state.caseDataReducer.caseData.location;
 
  const auditPropertiesData = state.auditPropertiesReducer.auditPropertiesData;
          
  return (
    (!auditPropertiesData.documentId ||
    isEmpty(auditPropertiesData.emdrClaimType)  && location !== CASE_SEARCH_CRITERIA_POPUP_LOCATIONS.CASE_SEARCH_PAGE)
  );
};
export const getAuditGroupsForClaim = (claimTypeCd, filteredAuditGroups) => {
  if(claimTypeCd){
    return filteredAuditGroups.filter(group => 
      group.claimTypeCd === claimTypeCd || group.claimTypeCd === "A"
    );
  }
  return filteredAuditGroups;
};



